import React from 'react'
import '../filtersearch/FilterSearch.css'
import { Link } from 'react-router-dom'

const EventsServiceDropdown = () => {
  return (
    
    <div className='filter-search-box pb-0'>
        <h2>Service</h2>
        <div className='scroll-filter-box'>
            <div className='filter-box mb-4'>
                <h3>Event</h3>
                <ul className='radio-box-checked'>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios9" id="" value="option9" />
                            <label className="form-check-label" for="">Hens Night</label>
                        </div>
                    </li>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios9" id="" value="option9" />
                            <label className="form-check-label" for="">Bucks Night</label>
                        </div>
                    </li>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios9" id="" value="option9" />
                            <label className="form-check-label" for="">Private</label>
                        </div>
                    </li>
                </ul>
            </div>
            <div className='filter-box mb-4'>
                <h3>Service</h3>
                <ul className='radio-box-checked'>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios" id="" value="option1" />
                            <label className="form-check-label" for="">Stripping (full nude)</label>
                        </div>
                    </li>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios" id="" value="option1" />
                            <label className="form-check-label" for="">Topless</label>
                        </div>
                    </li>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios" id="" value="option1" />
                            <label className="form-check-label" for="">Escorting</label>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
  )
}

export default EventsServiceDropdown
